<template>
    <div>
        <table class="harvestPlanTeamTable v-datatable v-table theme--light">
            <thead>
                <tr>
                    <th style="min-width: 100px; border-bottom: 1px solid rgba(0,0,0,0.12);" class="pa-0 font-weight-bold"><div class="row">Notes</div></th>
                    <th style="min-width: 100px; border-bottom: 1px solid rgba(0,0,0,0.12);" class="pa-0 font-weight-bold"><div class="row">Location</div></th>
                    <th style="min-width: 100px; border-bottom: 1px solid rgba(0,0,0,0.12);" class="pa-0 font-weight-bold"><div class="row">Variety</div></th>
                    <th style="min-width: 100px; border-bottom: 1px solid rgba(0,0,0,0.12);" class="pa-0 font-weight-bold"><div class="row">Packaging</div></th>
                    <th style="min-width: 100px; border-bottom: 1px solid rgba(0,0,0,0.12);" class="pa-0 font-weight-bold"><div class="row"><span style="text-align:center">Volume<br/>{{`${selectedUOM == $Constants.HARVESTPLAN_UOM_ENUM.KG.ID ? '(Kgs)' : '(Trays)'}`}}</span></div></th>
                    <th style="min-width: 100px; border-bottom: 1px solid rgba(0,0,0,0.12);" class="pa-0 font-weight-bold"><div class="row"><span style="text-align:center">Pick Rate<br/>{{`${selectedUOM == $Constants.HARVESTPLAN_UOM_ENUM.KG.ID ? '(Derived Kgs/Hr)' : '(Derived Pun/Hr)'}`}}</span></div></th>
                    <th style="min-width: 100px; border-bottom: 1px solid rgba(0,0,0,0.12);" class="pa-0 font-weight-bold"><div class="row">Pay Style</div></th>
                    <th style="min-width: 90px; border-bottom: 1px solid rgba(0,0,0,0.12);" class="pa-0 font-weight-bold"><div class="row">Pay Rate</div></th>
                    <th style="min-width: 120px; border-bottom: 1px solid rgba(0,0,0,0.12);" class="pa-0 font-weight-bold"><div class="row">Chariot Location</div></th>
                    <th style="min-width: 120px; border-bottom: 1px solid rgba(0,0,0,0.12);" class="pa-0 font-weight-bold"><div class="row">Pick Style</div></th>
                    <th style="min-width: 75px; border-bottom: 1px solid rgba(0,0,0,0.12);" class="pa-0 font-weight-bold"><div class="row">Vol/Hr</div></th>
                    <th style="min-width: 100px; border-bottom: 1px solid rgba(0,0,0,0.12);" class="pa-0 font-weight-bold"><div class="row">Time in Location</div></th>
                </tr>
            </thead>            
            <draggable :list="teamDetails" :group="berriesHarvestPlanTeamID" @start="drag=true" @end="onDropCallback" tag="tbody" handle=".handle" :move="checkMove">
                <tr v-for="(detail, i) in teamDetails" :key="detail.BerriesHarvestPlanTeamDetailID">
                    <td class="leftBorder rightBorder" @click.stop="showNotesDialog(detail)" tabindex="0" @keydown.enter.stop="showNotesDialog(detail)" :ref="detail.BerriesHarvestPlanTeamDetailID">
                        <div v-if="detail.Notes">
                            <span v-for="(note, j) in detail.Notes.split(',')" :key="j">
                                <v-avatar :class="`${$Constants.HARVESTPLAN_NOTICATIONS.find(c => c.ID == note.trim()).Color} ma-1`" size="16"></v-avatar>
                            </span>
                        </div>
                    </td>
                    <td class="leftBorder rightBorder" :class="detail.NuPointSprays.some(x => x.Withholding) ? detail.NuPointSprays.filter(x => x.Withholding)[0].WithholdColour : ''">
                        <div class="row">
                            <v-layout row fluid fill-height>
                                <v-flex shrink>
                                    <v-tooltip v-model="detail.ShowPHF" top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-chip dark small v-if="detail.NuPointSprays.some(x => x.PHF)" color="brown" v-bind="attrs" v-on="on" class="ica-icon">{{ getPHFDays(detail) }}</v-chip>
                                        </template>
                                        PHF
                                    </v-tooltip>
                                </v-flex>
                                <v-flex>
                                    <span v-if="detail.NuPointSprays.length > 0">                                        
                                        <v-tooltip v-model="detail.ShowNuPointSprayDetails" top>
                                            <template v-slot:activator="{ on, attrs }">                            
                                                <span><v-img v-if="detail.NuPointSprays.some(x => x.Withholding)" :src="require('@/assets/spray.png')" width="25px" @click="detail.ShowNuPointSprayDetails = !detail.ShowNuPointSprayDetails" v-bind="attrs" v-on="on"></v-img></span>
                                                <span><v-chip dark v-if="detail.NuPointSprays.some(x => x.ICA)" :color="detail.NuPointSprays.filter(x => x.ICA)[0].ICAColour" small v-bind="attrs" v-on="on" class="ica-icon">ICA</v-chip></span>
                                            </template>
                                            <NuPointSprayDetails :nuPointSprayModels="detail.NuPointSprays" :show="detail.ShowNuPointSprayDetails" />
                                        </v-tooltip>
                                    </span>
                                </v-flex>
                                <v-flex ml-2 xs2>
                                    <v-icon @mousedown="locationDrag = true" v-if="showMoveUpLocation(detail)" class="handle location-drag">drag_handle</v-icon>
                                </v-flex>
                                <v-flex xs10>
                                    <span @mousedown="locationDrag = false" class="handle">
                                        {{ detail.LocationName }} 
                                    </span>
                                </v-flex>                                
                                <v-flex shrink>
                                    <div style="width: 90px" class="locationMoveButtons">
                                        <v-btn v-if="showMoveUpLocation(detail)" :disabled="i == 0 || updatingHarvestPlan" icon small color="primary" @click="moveUpLocation(detail)"><v-icon style="transform: rotateZ(270deg)">keyboard_tab</v-icon></v-btn>
                                        <v-btn v-else :disabled="i == 0 || updatingHarvestPlan" icon small color="primary" @click="moveUpDetail(detail)"><v-icon style="transform: rotateZ(90deg)">keyboard_backspace</v-icon></v-btn>
                                        <v-btn v-if="showMoveDownLocation(detail)" :disabled="i == getTeamDetails(berriesHarvestPlanTeamID).length - 1 || updatingHarvestPlan" icon small color="primary" @click="moveDownLocation(detail)"><v-icon style="transform: rotateZ(90deg)">keyboard_tab</v-icon></v-btn>
                                        <v-btn v-else :disabled="i == getTeamDetails(berriesHarvestPlanTeamID).length - 1 || updatingHarvestPlan" icon small color="primary" @click="moveDownDetail(detail)"><v-icon style="transform: rotateZ(270deg)">keyboard_backspace</v-icon></v-btn>                                        
                                    </div>
                                </v-flex>
                            </v-layout>
                        </div>
                    </td>
                    <td class="leftBorder rightBorder" @click.stop="showPickHistoryDialog(detail)" tabindex="0" @keydown.enter.stop="showPickHistoryDialog(detail)" :ref="detail.BerriesHarvestPlanTeamDetailID">
                        <div class="row">
                            <v-layout row>
                                <v-flex grow>
                                     {{ detail.ProductVarietyName }} 
                                </v-flex>
                                <v-flex shrink>
                                    <v-icon color="info">info</v-icon>
                                </v-flex>
                            </v-layout>
                        </div>
                    </td>
                    <td class="leftBorder rightBorder" @click.stop="showPackagingDialog(detail)" tabindex="0" @keydown.enter.stop="showPackagingDialog(detail)" :ref="detail.BerriesHarvestPlanTeamDetailID">
                        <div class="row" @click="editRow = detail">                            
                            <div class="row">
                                {{ detail.PlantUnitName }}
                            </div>
                        </div>
                    </td>
                    <td class="leftBorder rightBorder"
                    :id="'volume-'+detail.BerriesHarvestPlanTeamDetailID"
                     @click="showEditVolume(i, detail)" tabindex="0" @focus="showEditVolume(i, detail)" @keydown.esc="hideEditVolume(i, detail, false)">
                        <div v-if="!editVolume[i]" class="row">
                            {{ `${formatVolume(detail.VolumeUOM)}`}}
                        </div>
                        <div class="row" v-else>      
                            <EditTableCell                            
                                style="width: 120px;"
                                :rules="[rules.requiredNumber, rules.integerOnly, rules.fromAToB(0, 99999)]"
                                :value="detail.VolumeUOM == null ? '' : detail.VolumeUOM.toString()"
                                @input="handleVolume(detail, i, $event)"
                                @close="hideEditVolume(i, detail, $event)" 
                                :loading="updatingHarvestPlan">
                            </EditTableCell>
                        </div>                     
                    </td>
                    <td class="leftBorder rightBorder"
                    :id="'pickRate-'+detail.BerriesHarvestPlanTeamDetailID"
                     @click="showEditPickRate(i)" tabindex="0" @focus="showEditPickRate(i)" @keydown.esc="hideEditPickRate(i, detail, false)">
                        <div v-if="!editPickRate[i]" class="row">
                            {{ `${formatPickRate(detail.PickRateUOM)}` }}
                        </div>
                        <div class="row" v-else>      
                            <EditTableCell                            
                                style="width: 120px;"
                                :rules="[oneDecimal]"                               
                                :value="detail.PickRateUOM == null ? '' : detail.PickRateUOM.toString()"
                                @input="handlePickRate(i, detail, $event)"
                                @close="hideEditPickRate(i, detail, $event)" 
                                :loading="updatingHarvestPlan">
                            </EditTableCell>
                        </div>
                    </td>
                    <td class="leftBorder rightBorder" @focus="showEditPayStyle(i, $event)" tabindex="0" @keydown.esc="esc">
                        <div v-if="!editPayStyle[i]" class="row">
                            {{ detail.PayStyle }}
                        </div>
                        <div class="row" v-else>
                            <v-autocomplete
                                style="width: 130px;" 
                                :menu-props="{ 'value': true }"
                                label="Pay Style"
                                :items="$Constants.HARVESTPLAN_PAYSTYLE"
                                @input="handlePayStyle(detail, i, $event)"
                                @mouseup.stop
                                @blur="hideEditPayStyle(i,$event)" 
                                hide-details
                                dense
                                outline
                                :loading="updatingHarvestPlan"                                                               
                                v-model="detail.PayStyle"
                                item-value="ID"
                                item-text="Name"
                                >
                            </v-autocomplete>
                        </div>
                    </td>
                    <td class="leftBorder rightBorder"
                    :id="'payrate-'+detail.BerriesHarvestPlanTeamDetailID"
                    @click="showEditPayRate(i)" tabindex="0" @focus="showEditPayRate(i)" @keydown.esc="hideEditPayRate(i, detail, false)">
                        <div v-if="!editPayRate[i]" class="row">
                            {{ `${detail ? getCurrencySymbol + (Math.round((detail.OverriddenPayRate || detail.PayRate) * 100) / 100).toFixed(2) : 'N/A'}` }}
                            <v-icon small v-if="payrateDisabled">lock</v-icon>
                        </div>
                        <div class="row" v-else>
                            <EditTableCell                            
                                style="width: 120px;"
                                clearable
                                :rules="[twoDecimal]"                               
                                :value="detail.OverriddenPayRate == null ? (detail.PayRate == null ? '0.00' : detail.PayRate.toString()) : detail.OverriddenPayRate.toString()"
                                @input="handlePayRate(i, detail, $event)"
                                @close="hideEditPayRate(i, detail, $event)" 
                                :loading="updatingHarvestPlan">
                            </EditTableCell>
                        </div>
                    </td>
                    <td class="leftBorder rightBorder" 
                    :id="'chariot-'+detail.BerriesHarvestPlanTeamDetailID"
                    @click="showEditChariot(i)" tabindex="0" @focus="showEditChariot(i)" @keydown.esc="hideEditChariot(i, detail, false)">
                        <div v-if="!editChariot[i]" class="row-left">
                            {{ detail.ChariotLocation }}
                        </div>
                        <div class="row" v-else>
                            <v-text-field
                                style="width: 120px;"                                
                                :loading="updatingHarvestPlan"                                
                                clearable
                                label=""
                                hide-details                                                                                           
                                outline
                                type="string"
                                autofocus                            
                                single-line
                                maxlength=12
                                @keydown.enter="hideEditChariot(i, detail, true)"
                                @blur="hideEditChariot(i, detail, false)"
                                v-model="detail.ChariotLocation">                                     
                            </v-text-field>
                        </div>
                    </td>
                    <td class="leftBorder rightBorder" 
                    :id="'pickStyle-'+detail.BerriesHarvestPlanTeamDetailID"
                    @click.stop="showEditPickStyle(i, $event)" tabindex="0" @keydown.enter.stop="showEditPickStyle(i, $event)" @keydown.esc.stop="hideEditPickStyle(i)">                       
                        <div class="row-left">
                            {{ detail.PickStyle }}
                            <v-menu                                
                                v-model="editPickStyle[i]"
                                :close-on-content-click="false"
                                :position-x="x"
                                :position-y="y"
                                absolute
                                offset-y
                                >
                                <v-card>
                                    <v-list>
                                        <v-list-tile @click="detail.PickStyle=''; hideEditPickStyle(i)">
                                            <v-list-tile-title :class="'red--text'">Clear</v-list-tile-title>
                                        </v-list-tile>
                                        <v-divider></v-divider>
                                        <v-list-tile @click="detail.PickStyle=$Constants.HARVESTPLAN_PICKSTYLE_ENUM.TRADITIONAL.ID; hideEditPickStyle(i)">
                                            <v-list-tile-title :class="detail.PickStyle==$Constants.HARVESTPLAN_PICKSTYLE_ENUM.TRADITIONAL.ID ? 'green--text' : ''">{{ $Constants.HARVESTPLAN_PICKSTYLE_ENUM.TRADITIONAL.Name }}</v-list-tile-title>
                                        </v-list-tile>
                                        <v-divider></v-divider>
                                        <v-list-tile @click="detail.PickStyle=$Constants.HARVESTPLAN_PICKSTYLE_ENUM.PNP.ID; hideEditPickStyle(i)">
                                            <v-list-tile-title :class="detail.PickStyle==$Constants.HARVESTPLAN_PICKSTYLE_ENUM.PNP.ID ? 'green--text' : ''">{{ $Constants.HARVESTPLAN_PICKSTYLE_ENUM.PNP.Name }}</v-list-tile-title>
                                        </v-list-tile>
                                        <v-divider></v-divider>
                                        <v-list-tile @click="detail.PickStyle=$Constants.HARVESTPLAN_PICKSTYLE_ENUM.BURRO.ID; hideEditPickStyle(i)">
                                            <v-list-tile-title :class="detail.PickStyle==$Constants.HARVESTPLAN_PICKSTYLE_ENUM.BURRO.ID ? 'green--text' : ''">{{ $Constants.HARVESTPLAN_PICKSTYLE_ENUM.BURRO.Name }}</v-list-tile-title>
                                        </v-list-tile>
                                        <v-divider></v-divider>
                                        <v-list-tile @click="detail.PickStyle=$Constants.HARVESTPLAN_PICKSTYLE_ENUM.PICKERSPLATFORM.ID; hideEditPickStyle(i)">
                                            <v-list-tile-title :class="detail.PickStyle==$Constants.HARVESTPLAN_PICKSTYLE_ENUM.PICKERSPLATFORM.ID ? 'green--text' : ''">{{ $Constants.HARVESTPLAN_PICKSTYLE_ENUM.PICKERSPLATFORM.Name }}</v-list-tile-title>
                                        </v-list-tile>
                                        <v-divider></v-divider>                                   
                                    </v-list>
                                    <v-text-field
                                        style="width: 200px;"                                
                                        :loading="updatingHarvestPlan"                                        
                                        label="Other"
                                        hide-details
                                        outline
                                        type="string"
                                        maxlength=20
                                        :value="detail.PickStyle !== $Constants.HARVESTPLAN_PICKSTYLE_ENUM.PNP.ID && detail.PickStyle !== $Constants.HARVESTPLAN_PICKSTYLE_ENUM.TRADITIONAL.ID && detail.PickStyle !== $Constants.HARVESTPLAN_PICKSTYLE_ENUM.BURRO.ID && detail.PickStyle !== $Constants.HARVESTPLAN_PICKSTYLE_ENUM.PICKERSPLATFORM.ID ? detail.PickStyle : ''"
                                        @keydown.enter.stop="hideEditPickStyle(i)"
                                        @blur.stop="hideEditPickStyle(i)"
                                        @input="detail.PickStyle = $event">
                                    </v-text-field>
                                </v-card>
                            </v-menu>                            
                        </div>
                    </td>
                    <td class="leftBorder rightBorder">
                        <div class="row">
                            {{ formatVolumePerHour(detail.VolumePerHour) }}
                        </div>
                    </td>
                    <td class="leftBorder rightBorder">
                        <div class="row">
                            {{ formatTimeInLocation(detail.TimeInLocationMinutes) }}
                        </div>
                    </td>
                </tr>
            </draggable>
            <tfoot>
                <tr style="height:1px">
                    <td colspan="12" style="border-top: 1px solid rgba(0,0,0,0.12);"></td>
                </tr>
            </tfoot>
        </table>
        <HarvestPlanNotesDialog v-if="notesDialog" :editable="!isPast" :notes="editRow.Notes" @cancel="cancelNotes" @save="handleNotes"></HarvestPlanNotesDialog>
        <HarvestPlanPickHistoryDialog v-if="pickHistoryDialog" :location="editRow.LocationName" :cropLocationID="editRow.CropLocationID" :varietyID="editRow.VarietyID" :uom="selectedUOM" @cancel="cancelPickHistory"></HarvestPlanPickHistoryDialog>
        <HarvestPlanPackagingDialog v-if="packagingDialog" :plantUnits="plantUnits" :packages="editPackages" :uom="selectedUOM" @cancel="cancelPackages" @save="handlePackages"></HarvestPlanPackagingDialog>
        <success-dialog :DisplayDialog="showPayRateLockedConfirm" DialogIcon="error" DialogColour="error" :DialogTitle="'Pay Rate is Locked'" :DialogContents="'The Pay Rate has not been updated by changes to the Pick Rate or Volume.'" @ClickedOK="hidePayRateLocked"></success-dialog>
        <success-dialog :DisplayDialog="showPayRateResendPrompt" DialogIcon="error" DialogColour="error" :DialogTitle="'Resend Piece Rate Agreement'" :DialogContents="'Remember to email updated piece rate information to Teams.'" @ClickedOK="showPayRateResendPrompt = false"></success-dialog>
        <success-dialog :DisplayDialog="showNuPointWarning" DialogTitle="NuPoint Spray" DialogContents="WARNING! Location currently under NuPoint Spray" DialogColour="warning" DialogIcon="pan_tool" @ClickedOK="nuPointWarningDismissed()">
        </success-dialog>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import HarvestPlanNotesDialog from '@/components/harvestPlan/HarvestPlanNotesDialog.vue';
import HarvestPlanPickHistoryDialog from '@/components/harvestPlan/HarvestPlanPickHistoryDialog.vue';
import HarvestPlanPackagingDialog from '@/components/harvestPlan/HarvestPlanPackagingDialog.vue';
import EditTableCell from '@/components/berriesRoster/EditTableCell.vue';
import SuccessDialog from '@/components/generic/OkPopup.vue';
import UtilService from '@/services/utilService.js';
import validationRules from "@/helpers/validationrules";
import moment from 'moment';
import * as Constants from "@/helpers/constants";
import draggable from 'vuedraggable';
import NuPointSprayDetails from "@/components/nuPointSpray/NuPointSpray.vue"

export default {
    components: {
        HarvestPlanNotesDialog,
        HarvestPlanPickHistoryDialog,
        HarvestPlanPackagingDialog,
        EditTableCell,
        SuccessDialog,
        draggable,
        NuPointSprayDetails
    },
    data() {
        return {            
            notesDialog: false,
            pickHistoryDialog: false,
            packagingDialog: false,
            editing: false,
            editVolume:{},
            editChariot: {},
            editPayRate: {},
            editPickStyle: {},
            editPickRate: {},
            editPayStyle: {},
            editIndex: -1,
            editRow: null,
            editPackages: null,
            showPlantUnitDropDown: false,
            sortOrderTimeout: null,
            rules: validationRules.rules,
            x: 0,
            y: 0,
            drag: false,
            locationDrag: false,
            showPayRateLockedConfirm: false,
            showPayRateResendPrompt: false,
            showNuPointWarning: false
        }
    },
    props: {
        berriesHarvestPlanTeamID: {
            type: Number,
            required: true
        }
    },
    computed: {
        ...mapState("HarvestPlanStore", [            
            "harvestPlan",
            "plantUnits",
            "updatingHarvestPlan",
            "plantData"
        ]),
        ...mapGetters("HarvestPlanStore", [
            "getTeamDetails",
            "isPast",
            "selectedUOM"
        ]),
        teamDetails() {
            return this.getTeamDetails(this.berriesHarvestPlanTeamID);
        },
        getCurrencySymbol() {
            var selectedPlantData = this.plantData.find(x => x.PlantID == this.harvestPlan.PlantID)

            if(Constants.COMPANIES.CHINA.CompanyID == selectedPlantData.CompanyID){
                return '¥'
            }
            return '$'
        },
        teamAgreementSent() {
            return this.harvestPlan.Teams.find(t => t.BerriesHarvestPlanTeamID == this.berriesHarvestPlanTeamID).PieceRateAgreementSent;
        },
        payrateDisabled() {
            return this.teamAgreementSent && !this.$store.getters["UserStore/isAuthorised"]({accessRights: [{PlantID: this.harvestPlan.PlantID, Access:'Edit Piece Rates'}]});
        },
    },
    methods: {
        ...mapMutations("HarvestPlanStore", [
            "addTeamDetail"
        ]),
        ...mapActions("HarvestPlanStore", [
            "updateHarvestPlanTeam"
        ]),
        async onDropCallback(evt) {
            this.drag = false;            

            let sorted = this.teamDetails.sort(UtilService.sortAscending(d => (d.CropLocationSortOrder * 10) + d.SortOrder));
            let row = sorted[evt.oldIndex];
            let destination = sorted[evt.newIndex];
            
            if (evt.oldIndex < evt.newIndex) {     
                while(sorted.indexOf(destination) === evt.newIndex) {
                    if (this.locationDrag) {
                        sorted = this.moveDownLocation(row);
                    } else {
                        sorted = this.moveDownDetail(row);
                    }
                }
            } else if (evt.oldIndex > evt.newIndex) {
                while(sorted.indexOf(destination) === evt.newIndex) {
                    if (this.locationDrag) {
                        sorted = this.moveUpLocation(row);
                    } else {
                        sorted = this.moveUpDetail(row);
                    }
                }
            }
        },
        checkMove(evt) {            
            // If we are moving a group, then it must be to another group
            if (this.locationDrag) {
                if(!evt.related.innerHTML.includes('location-drag')) {
                    return false;
                }
            // We are moving individual items, then it must be in the same group (crop location)
            } else {
                if (evt.draggedContext.element.CropLocationID != evt.relatedContext.element.CropLocationID) {
                    return false;
                }
            }

            return true && !this.updatingHarvestPlan;
        },
        showMoveUpLocation(row) {
            let details = this.getTeamDetails(row.BerriesHarvestPlanTeamID).filter(d => d.CropLocationID == row.CropLocationID);

            return !details.some(d => d.SortOrder < row.SortOrder);
        },
        showMoveDownLocation(row) {
            let details = this.getTeamDetails(row.BerriesHarvestPlanTeamID).filter(d => d.CropLocationID == row.CropLocationID);

            return !details.some(d => d.SortOrder > row.SortOrder);
        },
        moveDownDetail(row) {
            let details = this.getTeamDetails(row.BerriesHarvestPlanTeamID);
            let newOrder = row.SortOrder + 1;

            details.filter(d => d.CropLocationID == row.CropLocationID).forEach(d => {
                if (d.SortOrder == newOrder) {
                    d.SortOrder--;
                }
            });

            row.SortOrder = newOrder;

            if(this.sortOrderTimeout != null){
                clearTimeout(this.sortOrderTimeout);
            }

            this.sortOrderTimeout = setTimeout(this.handleSortOrderChanged, 500);

            return details.sort(UtilService.sortAscending(d => (d.CropLocationSortOrder * 10) + d.SortOrder));
        },
        moveDownLocation(row) {
            let details = this.getTeamDetails(row.BerriesHarvestPlanTeamID);
            let newOrder = row.CropLocationSortOrder + 1;

            details.forEach(d => {
                if (d.CropLocationSortOrder == newOrder) {
                    d.CropLocationSortOrder--;
                }
            });

            details.filter(d => d.CropLocationID == row.CropLocationID).forEach(d => {
                d.CropLocationSortOrder = newOrder;
            });

            row.CropLocationSortOrder = newOrder;

            if(this.sortOrderTimeout != null){
                clearTimeout(this.sortOrderTimeout);
            }

            this.sortOrderTimeout = setTimeout(this.handleSortOrderChanged, 500);

            return details.sort(UtilService.sortAscending(d => (d.CropLocationSortOrder * 10) + d.SortOrder));
        },
        moveUpDetail(row) {
            let details = this.getTeamDetails(row.BerriesHarvestPlanTeamID);
            let newOrder = row.SortOrder - 1;

            details.filter(d => d.CropLocationID == row.CropLocationID).forEach(d => {
                if (d.SortOrder == newOrder) {
                    d.SortOrder++;
                }
            });

            row.SortOrder = newOrder;

            if(this.sortOrderTimeout != null){
                clearTimeout(this.sortOrderTimeout);
            }

            this.sortOrderTimeout = setTimeout(this.handleSortOrderChanged, 500);

            return details.sort(UtilService.sortAscending(d => (d.CropLocationSortOrder * 10) + d.SortOrder));
        },
        moveUpLocation(row) {
            let details = this.getTeamDetails(row.BerriesHarvestPlanTeamID);
            let newOrder = row.CropLocationSortOrder - 1;

            details.forEach(d => {
                if (d.CropLocationSortOrder == newOrder) {
                    d.CropLocationSortOrder++;
                }
            });

            details.filter(d => d.CropLocationID == row.CropLocationID).forEach(d => {
                d.CropLocationSortOrder = newOrder;
            });

            row.CropLocationSortOrder = newOrder;

            if(this.sortOrderTimeout != null){
                clearTimeout(this.sortOrderTimeout);
            }

            this.sortOrderTimeout = setTimeout(this.handleSortOrderChanged, 500);

            return details.sort(UtilService.sortAscending(d => (d.CropLocationSortOrder * 10) + d.SortOrder));
        },
        async handleSortOrderChanged() {
            this.sortOrderTimeout = null;
            await this.updateHarvestPlanTeam(this.berriesHarvestPlanTeamID);
        },
        showNotesDialog(row) {
            this.editRow = row;      
            this.notesDialog = true;            
        },
        showPickHistoryDialog(row) {
            this.editRow = row;
            this.pickHistoryDialog = true;
        },
        showPackagingDialog(row) {
            if (this.isPast) {
                return;
            }

            this.editRow = row;
            this.editPackages = this.getTeamDetails(this.berriesHarvestPlanTeamID)
                                .filter(t => t.CropLocationID == this.editRow.CropLocationID && t.VarietyID == this.editRow.VarietyID)
                                .map(t => {
                                    return {
                                        PlantUnitID: t.PlantUnitID,
                                        VolumeUOM: t.VolumeUOM,
                                        VolumeKg: t.VolumeKg,
                                        ReadOnly: t.BerriesHarvestPlanTeamDetailID != this.editRow.BerriesHarvestPlanTeamDetailID
                                    }
                                });

            this.packagingDialog = true;
        },
        showEditVolume(index, detail) {
            if (this.isPast) {
                return;
            }

            if (this.editing) {
                return;
            }

            this.editIndex = index;

            if (detail.NuPointSprays.some(n => n.Withholding)) {
                this.showNuPointWarning = true;                
                return;
            }

            this.$set(this.editVolume, index, true);
            this.editing = true;
        },
        hideEditVolume(index, detail, isEnter) {
            this.editing = false;         
            this.$set(this.editVolume, index, false);
            if(isEnter && detail.nextBerriesHarvestPlanTeamDetailID) {
                document.getElementById('volume-'+detail.nextBerriesHarvestPlanTeamDetailID).click();
            }
        },
        showEditChariot(index) {
            if (this.isPast) {
                return;
            }

            if (this.editing) {
                return;
            }

            this.$set(this.editChariot, index, true);
            this.editing = true;
        },
        showEditPayRate(index) {
            if (this.isPast) {                
                return;
            }

            if(this.payrateDisabled) {                
                return;
            }

            if (this.editing) {                
                return;
            }

            this.$set(this.editPayRate, index, true);
            this.editing = true;
        },
        async hideEditChariot(index, detail, isEnter) {
            await this.updateHarvestPlanTeam(this.berriesHarvestPlanTeamID);
            this.editing = false;
            this.$set(this.editChariot, index, false);
            if(isEnter && detail.nextBerriesHarvestPlanTeamDetailID) {
                document.getElementById('chariot-'+detail.nextBerriesHarvestPlanTeamDetailID).click();
            }
        },
        async hideEditPayRate(index, detail, isEnter) {            
            await this.updateHarvestPlanTeam(this.berriesHarvestPlanTeamID);
            this.editing = false;
            this.$set(this.editPayRate, index, false);
            if(isEnter && detail.nextBerriesHarvestPlanTeamDetailID) {
                document.getElementById('payrate-'+detail.nextBerriesHarvestPlanTeamDetailID).click();
            }
        },
        showEditPickStyle(index, e) { 
            if (this.isPast) {
                return;
            }

            if (e.clientX) {
                this.x = e.clientX;
                this.y = e.clientY;
            } else {
                let tdOffset = this.offset(e.srcElement);
                this.x = tdOffset.left;
                this.y = tdOffset.top;
            }          

            this.$nextTick(() => {
                this.$set(this.editPickStyle, index, true);
            });
        },
        offset(el) {
            var rect = el.getBoundingClientRect(),
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
        },
        async hideEditPickStyle(index) {            
            await this.updateHarvestPlanTeam(this.berriesHarvestPlanTeamID);
            this.$set(this.editPickStyle, index, false);
        },
        showEditPickRate(index) {
            if (this.isPast) {
                return;
            }

            if (this.editing) {
                return;
            }

            this.$set(this.editPickRate, index, true);
            this.editing = true;
        },
        hideEditPickRate(index, detail, isEnter) {
            this.editing = false;
            this.$set(this.editPickRate, index, false);
            if(isEnter && detail.nextBerriesHarvestPlanTeamDetailID) {
                document.getElementById('pickRate-'+detail.nextBerriesHarvestPlanTeamDetailID).click();
            }
        },
        // eslint-disable-next-line
        showEditPayStyle(index, event) {
            //console.log('edit paystyle', this.isPast, this.editing, event)
            if (this.isPast) {
                return;
            }

            if (this.editing) {
                return;
            }

            this.$set(this.editPayStyle, index, true);
            this.editing = true;
        },
        // eslint-disable-next-line
        hideEditPayStyle(index, event) 
        {   
            //console.log('hide edit paystyle', event)
            this.editing = false;            
            this.$set(this.editPayStyle, index, false);
        },
        async handleNotes(result) {            
            this.editRow.Notes = result.notes;
            this.notesDialog = false;

            if (result.applyToAll) {
                let match = this.getTeamDetails(null).filter(t => t.CropLocationID == this.editRow.CropLocationID);
                match.forEach(m => {
                    m.Notes = result.notes;
                });
            }

            await this.updateHarvestPlanTeam(this.berriesHarvestPlanTeamID);         

            this.$refs[this.editRow.BerriesHarvestPlanTeamDetailID][0].focus();
        },
        cancelNotes() {
            this.notesDialog = false;
            this.$refs[this.editRow.BerriesHarvestPlanTeamDetailID][0].focus();
        },
        cancelPickHistory() {            
            this.pickHistoryDialog = false;
            this.$refs[this.editRow.BerriesHarvestPlanTeamDetailID][1].focus();
        },
        async handlePackages(results) {
            // lets try and find a result for the edit row
            let matchingResult = results.find(r => r.PlantUnitID == this.editRow.PlantUnitID);

            // If we didn't find a match, then update the edit row to the first result.
            if (!matchingResult) {
                let nonReadOnlyResults = results.filter(r => !r.ReadOnly);
                if (nonReadOnlyResults.length > 0) {
                    this.editRow.PlantUnitID = nonReadOnlyResults[0].PlantUnitID;
                    this.editRow.PlantUnitName = nonReadOnlyResults[0].UnitName;
                } else {
                    console.log('No package unit selected');
                    return;
                }
            }

            let teamDetails = this.getTeamDetails(this.berriesHarvestPlanTeamID);

            // Lets go and update / create for all results
            results.forEach(result => {                
                let match = teamDetails.find(t => t.CropLocationID == this.editRow.CropLocationID && t.VarietyID == this.editRow.VarietyID && t.PlantUnitID == result.PlantUnitID);

                if (match) {
                    match.VolumeUOM = result.Volume;
                } else {
                    // Create a new row
                    let newRow = Object.assign({}, this.editRow);
                    newRow.BerriesHarvestPlanTeamDetailID = null;
                    newRow.PlantUnitID = result.PlantUnitID;
                    newRow.PlantUnitName = result.UnitName;
                    newRow.VolumeUOM = result.Volume || 0;
                    newRow.SortOrder = 0;

                    this.addTeamDetail(newRow);
                }                
            })

            await this.updateHarvestPlanTeam(this.berriesHarvestPlanTeamID);

            this.packagingDialog = false;
        },
        cancelPackages() {
            this.packagingDialog = false;
            this.$refs[this.editRow.BerriesHarvestPlanTeamDetailID][2].focus();
        },
        async handleVolume(detail, index, event) {
            var volume = event.value;
            var isEnter = event.isEnter;
            if (!isNaN(volume) && !isNaN(parseInt(volume))) {
                detail.VolumeUOM = parseInt(volume);
            } else {
                detail.VolumeUOM = null;
            }

            await this.updateHarvestPlanTeam(this.berriesHarvestPlanTeamID);
            this.hideEditVolume(index, detail, isEnter);
        },
        async handlePickRate(index, detail, event) {
            var pickRate = event.value;
            var isEnter = event.isEnter;
            detail.PickRateUOM = pickRate;
            await this.updateHarvestPlanTeam(this.berriesHarvestPlanTeamID);
            if(this.payrateDisabled){
                this.showPayRateLockedConfirm = true;
            }
            else if(this.teamAgreementSent) {
                this.showPayRateResendPrompt = true;
            }

            this.hideEditPickRate(index, detail, isEnter);
        },
        async handlePayRate(index, detail, event) {
            var payRate = event.value;
            var isEnter = event.isEnter;
            detail.OverriddenPayRate = payRate;
            if(this.teamAgreementSent) {
                this.showPayRateResendPrompt = true;
            }

            this.hideEditPayRate(index, detail, isEnter);
        },
        async handlePayStyle(detail, index, payStyle) {
            var bulkSetPayStyle = index == 0

            detail.PayStyle = payStyle;
            if(bulkSetPayStyle){
                var emitArgs = { 
                    "payStyle": payStyle,
                    "index": index,
                    "harvestTeamID": this.berriesHarvestPlanTeamID
                }
                this.$emit("changePayStyle", emitArgs)
            }

            await this.updateHarvestPlanTeam(this.berriesHarvestPlanTeamID);
            this.hideEditPayStyle(index);
            
        },
        nuPointWarningDismissed() {
            this.showNuPointWarning = false;
            
            this.$set(this.editVolume, this.editIndex, true);
            this.editing = true;
        },
        getPHFDays(detail) {
            let totalDays = 0;

            detail.NuPointSprays.forEach(s => {
                if (s.PHFDays > totalDays) {
                    totalDays = s.PHFDays;
                }
            });

            return totalDays;
        },
        hidePayRateLocked() {
            this.showPayRateLockedConfirm = false;
        },
        oneDecimal(v){
            if(v == null || !v.toString().match(/^[0-9]{1,15}.?[0-9]{0,1}$/)){
                return "Please enter a number in the format of XXXXX.X";
            }

            return false;
        },
        twoDecimal(v){
            if (v == null || v == '') {
                return true;
            }

            if(v != null && !v.toString().match(/^[0-9]{1,15}.?[0-9]{0,2}$/)){
                return "Please enter a number in the format of XXXXX.XX";
            }

            return false;
        },
        formatVolume(v) {                       
            if (v !== null) {
                let result = UtilService.thousandsSeparators(v);

                return result;
            }

            return 'N/A';
        },
        formatPickRate(v) {
            if (v !== null) {                
                return v;
            }

            return 'N/A';
        },
        formatVolumePerHour(v) {
            if (v !== null) {
                let result = UtilService.thousandsSeparators(v);
                return result;
            }

            return 'N/A';
        },
        formatTimeInLocation(v) {
            if (v !== null)
            {
                let start = moment.utc().startOf('day');
                let end = moment.utc().startOf('day').add({ minutes: v });

                if (end.diff(start, 'hours') >= 24) {
                    return '> 24hr';
                }

                return end.format('H[hr] mm[m]');
            }

            return 'N/A';
        },
        esc() {
            document.activeElement.blur()
        }
    }
}
</script>
<style scoped>
.ica-icon {
    font-size: 11px;
    width: 26px;
    justify-content: center;
}
.handle {
    cursor: grab;
}

.row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.row-left {
    display: flex;
    flex-direction: row;
    align-items: left;
    justify-content: left;
}

.leftBorder {
    border-left: 1px solid rgba(0,0,0,0.12);
}

.rightBorder {
    border-right: 1px solid rgba(0,0,0,0.12);
}

.harvestPlanTeamTable tbody td {
    font-size: 18px;
}

.locationMoveButtons .v-btn:focus {
    background: black!important; 
}
</style>